module.exports = __webpack_public_path__ + "img/glassquality_1.f60a5764.png";